module.exports = __webpack_public_path__ + "static/media/ic_pa_b6_myway.67500843.svg";